import xhr from './fetch'

/**
 * XHR 请求接口定义
 * @param  {String} options.method     请求方法（默认为 post）
 * @param  {String} options.url        请求路径
 * @param  {String} options.forceMock  是否强制走本地mock服务 （默认为 false）
 * @param  {Object} options.header     请求头
 * @param  {Object} options.body       请求体
 * @return {Promise}
 *
 */
export default xhr
